(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gringa-hero-parallax"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__gringaHeroParallax) return;
    window.__gringaHeroParallax = true;

    var reduz = window.matchMedia('(prefers-reduced-motion: reduce)');
    var alvos = [];
    var pendente = false;

    function coletar() {
      alvos = [];
      document.querySelectorAll('.hero--parallax').forEach(function (secao) {
        var media = secao.querySelector('.hero__media-grid');
        if (media) alvos.push({ secao: secao, media: media });
      });
    }

    function atualizar() {
      pendente = false;
      if (reduz.matches) return;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      for (var i = 0; i < alvos.length; i++) {
        var r = alvos[i].secao.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) continue;
        // -1 quando a seção está entrando por baixo, +1 quando já saiu por cima
        var p = (vh - r.top) / (vh + r.height);
        if (p < 0) p = 0;
        if (p > 1) p = 1;
        var sobra = r.height * 0.01 *
          (parseFloat(getComputedStyle(alvos[i].secao).getPropertyValue('--hero-parallax')) || 0) / 2;
        alvos[i].media.style.transform =
          'translate3d(0,' + ((p - 0.5) * 2 * sobra).toFixed(1) + 'px,0)';
      }
    }

    function aoRolar() {
      if (!pendente) { pendente = true; requestAnimationFrame(atualizar); }
    }

    function iniciar() { coletar(); atualizar(); }

    document.addEventListener('DOMContentLoaded', iniciar);
    if (document.readyState !== 'loading') iniciar();
    window.addEventListener('scroll', aoRolar, { passive: true });
    window.addEventListener('resize', function () { coletar(); aoRolar(); }, { passive: true });
    // o editor de tema recarrega seções sem recarregar a página
    document.addEventListener('shopify:section:load', iniciar);
    document.addEventListener('shopify:section:unload', iniciar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gringa-parallax"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root || root.dataset.gpxInit) return;
    root.dataset.gpxInit = '1';
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-gpx-slide]'));
    if(!slides.length) return;
    var intensity = (parseFloat(root.dataset.intensity)||10)/100;
    var dots = Array.prototype.slice.call(root.querySelectorAll('.gpx__dot'));
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    slides.forEach(function(sl){ sl.__media = sl.querySelector('[data-gpx-media]'); });

    // reveal
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting) e.target.classList.add('is-in');
      });
    }, {threshold: 0.35});
    slides.forEach(function(sl){ io.observe(sl); });

    // active section -> show dots
    var sio = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ root.classList.toggle('gpx--active', e.isIntersecting && e.intersectionRatio>0.25); });
    }, {threshold:[0,.25,.5]});
    sio.observe(root);

    // dot click -> scroll to slide
    dots.forEach(function(d){
      d.addEventListener('click', function(){
        var i = parseInt(d.dataset.i,10);
        var top = root.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({top: top + i*window.innerHeight, behavior:'smooth'});
      });
    });

    var ticking = false;
    function update(){
      ticking = false;
      var vh = window.innerHeight;
      var active = 0;
      for(var k=0;k<slides.length;k++){
        var sl = slides[k];
        var r = sl.getBoundingClientRect();
        if(!reduce && sl.__media){
          var p = r.top / vh; if(p<0)p=0; if(p>1)p=1;
          var amt = r.height * intensity;
          var z = root.dataset.zoom === 'true' ? ' scale('+(1+p*0.05).toFixed(3)+')' : '';
          sl.__media.style.transform = 'translate3d(0,'+(p*amt).toFixed(1)+'px,0)'+z;
        }
        if(r.top <= vh*0.5) active = k;
      }
      if(dots.length){
        for(var j=0;j<dots.length;j++) dots[j].classList.toggle('is-on', j===active);
      }
    }
    function onScroll(){ if(!ticking){ ticking=true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', onScroll, {passive:true});
    update();
    root.__gpxUpdate = update;
  }

  function boot(){ document.querySelectorAll('[data-gpx]').forEach(init); }
  if(document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  // Theme editor support
  document.addEventListener('shopify:section:load', function(e){
    var el = e.target.querySelector('[data-gpx]'); if(el) init(el);
  });
  document.addEventListener('shopify:section:select', function(e){
    var el = e.target.querySelector('[data-gpx]'); if(el && el.__gpxUpdate) el.__gpxUpdate();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
